<div class="container-fluid p-3 p-sm-5 h-100">
  <div class="row no-gutters h-100 align-items-center">
    <div class="row no-gutters col-md">
      <div class="p-3">
        <h2 class="text-allports font-weight-bold mb-4">
          Denied the purchase of cold and allergy medication?
        </h2>
        <p class="fs13">
          As you may be aware, beginning in 2005 Federal and State laws began
          requiring certain cold and allergy medications to be more strictly
          regulated. Sales of these medications are now monitored to help stop
          components of these medications from being diverted into the illicit
          manufacturing of methamphetamine and other dangerous drugs.
        </p>
        <p class="fs13">
          If you have attempted to purchase one of these regulated cold and
          allergy medications and were unable to do so, please follow the
          instructions below to see a summary of your purchase history along
          with applicable Federal, State and local laws.
        </p>
      </div>
    </div>
    <div class="h-m-100 row no-gutters col-md">
      <div
        class="w-100 ml-md-5 border rounded border-secondary bg-white shadow-md"
      >
        <div class="d-flex flex-column p-3 border-bottom">
          <h3 class="align-self-center font-weight-bold">
            Transaction Information
          </h3>
          <p class="align-self-center font-italic">
            Transaction must have occurred in the last 30 days.
          </p>
        </div>
        <div class="p-3">
          <form
            id="SearchForm"
            class="d-flex flex-column align-items-center"
            #searchForm="ngForm"
            (ngSubmit)="onSubmit(searchForm)"
          >
            <app-input
              class="w-100"
              id="TransactionId"
              label="Transaction ID*"
              type="text"
              [required]="true"
              [searchForm]="searchForm"
              validationErrorMessage="Please enter a Transaction ID"
              (updateValue)="onUpdateTransactionId($event)"
            ></app-input>
            <app-input
              class="w-100"
              id="LastName"
              label="Last Name*"
              type="text"
              [required]="true"
              [searchForm]="searchForm"
              validationErrorMessage="Please enter a Last Name"
              (updateValue)="onUpdateLastName($event)"
            ></app-input>
            <app-button
              class="d-flex p-2"
              [disabled]="processingRequest"
              label="SUBMIT"
              type="submit"
            ></app-button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="displayError"
    class="alert alert-danger position-absolute"
    role="alert"
  >
    <span class="mr-2"
      >An error occurred while processig your request, please try again.</span
    >
    <button
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close"
      (click)="toggleDisplayError()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div
    *ngIf="displayNoResults"
    class="alert alert-danger position-absolute"
    role="alert"
  >
    <span class="mr-2"
      >Transaction history could not be generated. Please verify your
      information.</span
    >
    <button
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close"
      (click)="toggleDisplayNoResults()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
